import { ReactElement } from 'react';

import { visitPaths } from '~libs.desktop.shared.paths';

import { ChipFilter } from '../ChipFilter';
import { appointmentConfirmationStatusFilterStorage } from '../../AppointmentsFilterPanel/fields/AppointmentConfirmationStatusField/AppointmentConfirmationStatusField.storage';
import { useAppointmentsFiltersContext } from '../../AppointmentFilter.context';

import { useAppointmentConfirmationStatusFilterLabel } from './AppointmentConfirmationStatusChipFilter.hooks';

export const AppointmentConfirmationStatusChipFilter = (): ReactElement | null => {
   const { getFilter } = useAppointmentsFiltersContext();

   const appointmentConfirmationStatuses = getFilter('appointmentConfirmationStatus');
   const label = useAppointmentConfirmationStatusFilterLabel(appointmentConfirmationStatuses);

   if (!appointmentConfirmationStatuses.length) {
      return null;
   }
   return (
      <ChipFilter
         label={label}
         searchParamKey={visitPaths.APPOINTMENT_CONFIRMATION_STATUS_SEARCH_PARAM}
         testId={'appointmentConfirmationStatus'}
         onClick={appointmentConfirmationStatusFilterStorage.deleteFilter}
      />
   );
};
